import { render, staticRenderFns } from "./ouItem.vue?vue&type=template&id=0b66e5f1&lang=pug&"
import script from "./ouItem.vue?vue&type=script&lang=js&"
export * from "./ouItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports